<template>
  <vx-card no-shadow>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-2/5 w-full">
        <h2>Danger Zone</h2>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Delete Report</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-button color="danger" @click="confirmDelete" class="ml-auto mt-2">Delete Report</vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  components: {},
  props: {
    report: Object
  },
  data() {
    return {
      reportId: ""
    };
  },
  methods: {
    confirmDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this Report?",
        accept: this.deleteReport
      });
    },
    async deleteReport() {
      await this.$store.dispatch("eodReports/deleteEodReport", this.reportId);
      this.$vs.notify({
        color: "success",
        title: "Success",
        text: "End of day report deleted"
      });
      this.$router.go(-1);
    }
  },
  created() {
    this.reportId = this.$route.params.id;
  }
};
</script>